import { Search } from 'lucide-react';
import { ChangeEvent, useEffect } from 'react';
import { Stack, Box, TextField } from '@mui/material';
// import { SelectChangeEvent } from '@mui/material/Select';

interface HPOFormControlsProps {
  // searchCategory: string;
  searchQuery: string;
  inputRef: React.RefObject<HTMLInputElement>;
  focusSearchField: () => void;
  // handleCategoryChange: (event: SelectChangeEvent<string>) => void;
  handleSearchChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  handleSearchClick: (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | React.KeyboardEvent<HTMLDivElement>,
  ) => void;
}

const HPOFormControls = ({
  // searchCategory,
  // handleCategoryChange,
  searchQuery,
  handleSearchChange,
  handleSearchClick,
  focusSearchField,
  inputRef,
}: HPOFormControlsProps) => {
  useEffect(() => {
    focusSearchField();
  }, [focusSearchField]);
  return (
    <Box sx={{ padding: '10px 0' }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{ justifyContent: 'flex-end', marginTop: '10px' }}
      >
        <TextField
          id="search-hpo"
          variant="outlined"
          placeholder="Search"
          size="small" //  This is the key to match button size
          onKeyDown={(e) => e.key === 'Enter' && handleSearchClick(e)}
          fullWidth
          value={searchQuery}
          inputRef={inputRef}
          onChange={handleSearchChange}
          sx={{ backgroundColor: 'background.paper' }}
          InputProps={{
            startAdornment: (
              <Search
                style={{
                  paddingRight: '0.5rem',
                }}
              />
            ),
          }}
        />
      </Stack>
    </Box>
  );
};

export default HPOFormControls;
